import { render, staticRenderFns } from "./ResultBig.vue?vue&type=template&id=868f6504&scoped=true&lang=pug"
import script from "./ResultBig.vue?vue&type=script&lang=js"
export * from "./ResultBig.vue?vue&type=script&lang=js"
import style0 from "./ResultBig.vue?vue&type=style&index=0&id=868f6504&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f6504",
  null
  
)

export default component.exports